import Form from "../components/Form";
import "./Home.css";
import React from "react";

function Home() {
  return (
    <>
      {" "}
      <div className="App">
        <header className="App-header">
          <img
            src={require("../assets/logo.jpg")}
            alt="Logo"
            style={{ width: "240px" }}
          />

          <div></div>
        </header>
      </div>
      <div className="App2">
        <Form />
      </div>
    </>
  );
}

export default Home;
